import { Controller } from "@hotwired/stimulus"

// Wires the inline-editable Tracking cell to PUT /admin/gifts/:id/redeemeds using the
// bootstrap-editable jQuery plugin, bound in connect()/disconnect() the same way
// templates_controller.js binds its own inline-editable fields.
//
// The update is handed to bootstrap-editable's `url` hook - a function, not a string - because
// that is the hook the plugin awaits. Its `success` callback is inspected synchronously and never
// awaited, so an async handler there could not surface an inline validation error.
class AdminGift {
  constructor(id) {
    this.id = id;
  }

  update(trackingNumber) {
    const csrfTokenTag = document.head.querySelector("meta[name=csrf-token]");
    const csrfToken = csrfTokenTag === null ? "" : csrfTokenTag.getAttribute("content");

    return $.ajax({
      url: `/admin/gifts/${this.id}/redeemeds`,
      type: "PUT",
      contentType: "application/json",
      data: JSON.stringify({ gift: { tracking_number: trackingNumber } }),
      headers: {
        "X-CSRF-Token": csrfToken,
        "X-Requested-With": "XMLHttpRequest",
        "Accept": "application/json, text/plain, */*"
      }
    });
  }
}

export default class extends Controller {
  connect() {
    this.scoped(".tracking-editable").editable({
      mode: "inline",
      display: false,
      url: function(params) {
        // bootstrap-editable calls url/success with `this` set to the plain editable element
        // (its `scope` option, set from `$element[0]`) - not a jQuery object.
        return new AdminGift(this.dataset.pk).update(params.value);
      },
      success: function(response, newValue) {
        this.textContent = newValue === "" ? "empty" : newValue;
      },
      error: function(xhr) {
        const data = xhr.responseJSON;
        const fieldErrors = data && data.errors && data.errors.tracking_number;
        return fieldErrors ? fieldErrors[0] : (xhr.responseText || xhr.statusText || "An error occurred");
      }
    });
  }

  disconnect() {
    this.scoped(".tracking-editable").editable("destroy");
  }

  // Scoped: every element this controller touches lives inside its own mount.
  scoped(selector) {
    return $(this.element).find(selector);
  }
}
